export default __webpack_public_path__ + "static/straingeBeast-dac847fc229e6bc648fd257daf7c728c.svg";